import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";

// 통합 이용약관, 개인정보처리방침 동의
const ConfirmPolicy = () => {
  const { openTermsService, openPrivacyPolicy } = useModal();
  const { register } = useFormContext();
  const { t } = useTranslation();
  return (
    <div className="form-item">
      <div className="flex">
        <input
          type="checkbox"
          id="confirmPolicy"
          {...register("confirmPolicy")}
        />
        <label className="inputArea-label" htmlFor="confirmPolicy"></label>
        <label className="form-input-label">
          {t("siteType.agreement1")}
          <a onClick={openTermsService}>
            <b className="text text--black">{t("siteType.agreement2")}</b>
          </a>
          {t("siteType.agreement3")}
          <a onClick={() => openPrivacyPolicy()}>
            <b className="text text--black">{t("siteType.agreement4")}</b>
          </a>
          {t("siteType.agreement7")}
        </label>
      </div>
      <div className="mg mt-20 form-item-delete">{t("siteType.info")}</div>
    </div>
  );
};

export default ConfirmPolicy;
